var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons for menu",
    clipPath: "url(#clip0_9899_1362)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.8448 14.1768C13.9943 14.1768 13.2217 14.5149 12.6529 15.0631L8.03314 11.8034C8.21396 11.4056 8.31543 10.9646 8.31543 10.5C8.31543 10.0355 8.21396 9.59439 8.03314 9.19675L12.6529 5.93686C13.2217 6.48511 13.9943 6.82339 14.8448 6.82339C16.5881 6.82339 18.0064 5.40509 18.0064 3.66177C18.0064 1.9183 16.5881 0.5 14.8448 0.5C13.1015 0.5 11.6832 1.9183 11.6832 3.66162C11.6832 4.12625 11.7847 4.56723 11.9653 4.96503L7.34573 8.22476C6.77689 7.67651 6.00433 7.33838 5.15381 7.33838C3.41049 7.33838 1.99219 8.75668 1.99219 10.5C1.99219 12.2433 3.41049 13.6616 5.15381 13.6616C6.00433 13.6616 6.77689 13.3235 7.34573 12.7752L11.9653 16.035C11.7847 16.4328 11.6832 16.8737 11.6832 17.3384C11.6832 19.0817 13.1015 20.5 14.8448 20.5C16.5881 20.5 18.0064 19.0817 18.0064 17.3384C18.0064 15.5951 16.5881 14.1768 14.8448 14.1768ZM14.8448 19.3095C13.7579 19.3095 12.8737 18.4253 12.8737 17.3384C12.8737 16.2515 13.7579 15.3672 14.8448 15.3672C15.9317 15.3672 16.8159 16.2515 16.8159 17.3384C16.8159 18.4253 15.9317 19.3095 14.8448 19.3095ZM5.15381 12.4711C4.06693 12.4711 3.18268 11.5869 3.18268 10.5C3.18268 9.41312 4.06693 8.52887 5.15381 8.52887C6.24069 8.52887 7.12494 9.41312 7.12494 10.5C7.12494 11.5869 6.24069 12.4711 5.15381 12.4711ZM12.8737 3.66162C12.8737 2.57474 13.7579 1.69049 14.8448 1.69049C15.9317 1.69049 16.8159 2.57474 16.8159 3.66162C16.8159 4.7485 15.9317 5.63275 14.8448 5.63275C13.7579 5.63275 12.8737 4.7485 12.8737 3.66162Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9899_1362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.de0e70a08f6746f5933d0bdb739de205.svg";
export { ForwardRef as ReactComponent };